import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
/**
 * Wrapper component that only renders the children if the user has the sufficient capability.
 *
 * @param capability the capability that is required to view the protected child component.
 * @param errorComponent the fallback component that will be rendered if the user does not have the sufficient capability.
 * @param children the protected child components we want to wrap.
 */ export var CapabilitySpecificComponent = function(param) {
    var capability = param.capability, errorComponent = param.errorComponent, children = param.children;
    var userHasSufficientCapability = useUserStore([
        "userHasSufficientCapability"
    ]).userHasSufficientCapability;
    var canView = userHasSufficientCapability(capability);
    if (!canView) {
        return errorComponent;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
